import React from 'react';
import ReactDOM from 'react-dom';
import {
  Route,
  Switch,
  BrowserRouter,
} from 'react-router-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

interface Webkit {
  messageHandlers: {
    /**
     * Added due to our call to addScriptMessageHandler.
     * @see: https://github.com/react-native-community/react-native-webview/blob/25552977852427cf5fdc7b233fd1bbc7c77c18b0/ios/RNCWebView.m#L1244
     */
    ReactNativeWebView: {
      postMessage(message: string): void;
    }
    /**
     * Added due to our call to addScriptMessageHandler.
     * @see: https://github.com/react-native-community/react-native-webview/blob/25552977852427cf5fdc7b233fd1bbc7c77c18b0/ios/RNCWebView.m#L214
     */
    ReactNativeHistoryShim: {
      postMessage(message: string): void;
    }
  }
}

declare global {
  interface Window {
    API: any;
    Scorm12API: any;
    webkit: Webkit;
    /**
     * A convenience API that we seem to expose in iOS.
     * Not sure whether Android does the same.
     * @see: https://github.com/react-native-community/react-native-webview/blob/25552977852427cf5fdc7b233fd1bbc7c77c18b0/ios/RNCWebView.m#L1128-L1146
     */
    ReactNativeWebView: {
      postMessage(msg: string): void;
    };
  }
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Switch>
        <Route exact path="/" render={() => <App />} />
      </Switch>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
